import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

// ----- BOM TYPE ADD EDIT  ----- //

export const addBomType = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_TYPE.CREATE}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchBomType = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchAllBom = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE.GET_ALL_BOM}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchBomTypeById = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE.GET_BY_ID}${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateBomType = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_TYPE.UPDATE}${payload._id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteBomType = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_TYPE.DELETE}`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Fetches supplier/product component types. The server scopes to Tier 1 unless the caller
 * names a `tier`, so multi-tier screens must pass the tier they are showing.
 */
export const getProductAssociates = async (params = {}) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE.GET_PRDUCT_ASSOC}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTier_1_ProductAssociates = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE.GET_PRDUCT_ASSOC}`, { params: { tier: 'Tier1' } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const clearHighlight = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_TYPE.CLEAR_HIGHLIGHT}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateBomTypeSequence = async (params) => {
  try {
    console.log('updateBomTypeSequence', params);
    return await apiClient.put(`${apiEndpoint}${API.BOM_TYPE.UPDATE_SEQUENCE}`, params);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
